import { FieldGroupsByLocatorMap } from '../../../types/policy';
import { getCharacteristic } from '../../../util/util';
import {
	removePendingRemoveFieldGroupsLocatorsFromFieldValues,
	updateFieldGroupsByLocatorWithPendingChanges,
} from '../../policy/util_sharedEndorsementAndRenewal';
import { FormBuilder, FormShape, RenewalFormTransformer } from '../types';

const getRenewalForm = (
	props: RenewalFormTransformer,
	name = 'renewalForm' as keyof FormShape<FormBuilder>,
) => {
	const { renewalData } = props;
	const { productConfig, policy, renewalUpdateObj } = renewalData;
	const { policyConfiguration } = productConfig;
	const renewalEffectiveDate = renewalUpdateObj.renewalStartTimestamp;
	const { characteristics } = policy;

	const characteristic = getCharacteristic(
		characteristics,
		renewalEffectiveDate,
	);

	const policyFieldValues = characteristic.fieldValues;
	const endorsementFieldValues = renewalUpdateObj.fieldValues;

	const policyFieldGroupsByLocator = characteristic.fieldGroupsByLocator;
	const mediaByLocator = characteristic.mediaByLocator;

	const pendingUpdateFieldGroups = renewalUpdateObj.updateFieldGroups;
	const addFieldGroups = renewalUpdateObj.addFieldGroups;
	const pendingRemoveFieldGroups = renewalUpdateObj.removeFieldGroups;
	const values = removePendingRemoveFieldGroupsLocatorsFromFieldValues(
		pendingRemoveFieldGroups,
		{ ...policyFieldValues, ...endorsementFieldValues },
	);

	const { fields, externalDataCalls } = policyConfiguration;

	const fieldGroupsByLocator: FieldGroupsByLocatorMap =
		updateFieldGroupsByLocatorWithPendingChanges(
			policyFieldGroupsByLocator,
			pendingUpdateFieldGroups,
			pendingRemoveFieldGroups,
		);

	return {
		[name]: {
			fields,
			fieldGroupsByLocator,
			addFieldGroups,
			mediaByLocator,
			externalDataCalls,
			values,
		} as FormBuilder,
	} as FormShape<FormBuilder>;
};

export default getRenewalForm;
